function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useAuthenticationStore from '@/stores/AuthenticationStore';
import React from 'react';
import { faBoltLightning, faCheck, faMoon, faSignOut, faSun, faWrench } from '@fortawesome/free-solid-svg-icons';
import useChannelStore from '@/stores/ChannelStore';
import { getChannelByName, updateChannel } from '@/actions/ChannelActions';
import { logoutUser } from '@/actions/UserActions';
import InputModal, { DefaultInput } from '@/components/InputModal';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { DynamicWebRoutes } from '@/utils/constants';
import { SettingPanels } from '@/types/client';
import { useShallow } from 'zustand/react/shallow';
import { Avatar, Menu, Text } from '@mantine/core';
import styles from './UserMenu.module.scss';
import Icon, { IconSizes } from './Icon';
import useAppStore from '@/stores/AppStore';
import { useDisclosure } from '@mantine/hooks';
function UserMenuItem(param) {
    var label = param.label, avatar = param.avatar, onClick = param.onClick, active = param.active;
    return /*#__PURE__*/ _jsx(Menu.Item, {
        onClick: onClick,
        closeMenuOnClick: false,
        classNames: {
            itemLabel: styles.itemLabel
        },
        variant: active ? 'active' : undefined,
        rightSection: active ? /*#__PURE__*/ _jsx(Icon, {
            size: IconSizes.SM,
            icon: faCheck
        }) : undefined,
        leftSection: /*#__PURE__*/ _jsx(Avatar, {
            size: "xs",
            src: avatar
        }),
        children: /*#__PURE__*/ _jsx(Text, {
            truncate: true,
            size: "sm",
            children: label
        })
    });
}
export function UserMenu(_param) {
    var children = _param.children, dropdownProps = _param.dropdownProps, props = _object_without_properties(_param, [
        "children",
        "dropdownProps"
    ]);
    var intl = useIntl();
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), adminChannelModalOpen = _useDisclosure[0], adminChannelModalHandlers = _useDisclosure[1];
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            user: state.user,
            provider: state.provider
        };
    })), user = _useAuthenticationStore.user, provider = _useAuthenticationStore.provider;
    var _useChannelStore = useChannelStore(useShallow(function(state) {
        return {
            channel: state.channel,
            setChannel: state.setChannel
        };
    })), currentChannel = _useChannelStore.channel, setChannel = _useChannelStore.setChannel;
    var channels = useChannelStore(useShallow(function(state) {
        var _state_managedChannels;
        return (_state_managedChannels = state.managedChannels) === null || _state_managedChannels === void 0 ? void 0 : _state_managedChannels.map(function(param) {
            var channel = param.channel;
            return channel;
        });
    }));
    var _React_useState = _sliced_to_array(React.useState(null), 2), pendingChannelId = _React_useState[0], setPendingChannelId = _React_useState[1];
    var _useAppStore = useAppStore(), toggleColorMode = _useAppStore.toggleColorMode, colorMode = _useAppStore.colorMode;
    var navigate = useNavigate();
    var isLightMode = colorMode === 'light';
    var showChannels = user != null && channels != null && channels.length > 0;
    React.useEffect(function() {
        if (currentChannel == null) {
            return;
        }
        setPendingChannelId(currentChannel._id);
    }, [
        currentChannel
    ]);
    var handleChannelChange = React.useCallback(function(channelId) {
        setPendingChannelId(channelId);
        updateChannel(channelId);
    }, [
        setPendingChannelId
    ]);
    var handleAdminChannelChange = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(channelName) {
            var channel;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getChannelByName(provider, channelName)
                        ];
                    case 1:
                        channel = _state.sent();
                        setChannel(channel);
                        return [
                            2
                        ];
                }
            });
        });
        return function(channelName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setChannel,
        provider
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Menu, _object_spread_props(_object_spread({}, props), {
                children: [
                    /*#__PURE__*/ _jsx(Menu.Target, {
                        children: children
                    }),
                    /*#__PURE__*/ _jsxs(Menu.Dropdown, _object_spread_props(_object_spread({}, dropdownProps), {
                        children: [
                            showChannels ? /*#__PURE__*/ _jsxs(React.Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.channelStack,
                                        children: [
                                            /*#__PURE__*/ _jsx(UserMenuItem, {
                                                label: user.displayName,
                                                avatar: user.avatar,
                                                onClick: function() {
                                                    return handleChannelChange(user._id);
                                                },
                                                active: user._id === pendingChannelId
                                            }, user._id),
                                            channels === null || channels === void 0 ? void 0 : channels.map(function(channel) {
                                                return /*#__PURE__*/ _jsx(UserMenuItem, {
                                                    label: channel.displayName,
                                                    avatar: channel.avatar,
                                                    onClick: function() {
                                                        return handleChannelChange(channel._id);
                                                    },
                                                    active: channel._id === pendingChannelId
                                                }, "".concat(channel._id, "-channel"));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Menu.Divider, {})
                                ]
                            }) : null,
                            (user === null || user === void 0 ? void 0 : user.admin) === true ? /*#__PURE__*/ _jsx(Menu.Item, {
                                closeMenuOnClick: true,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faBoltLightning
                                }),
                                onClick: adminChannelModalHandlers.open,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "194Y+K",
                                    defaultMessage: "Manage Channel"
                                })
                            }, "admin") : null,
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faWrench
                                }),
                                onClick: function() {
                                    return navigate(DynamicWebRoutes.SETTINGS(SettingPanels.GENERAL));
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "D3idYv",
                                    defaultMessage: "Settings"
                                })
                            }, "settings"),
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                closeMenuOnClick: false,
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: isLightMode ? faMoon : faSun
                                }),
                                onClick: toggleColorMode,
                                children: isLightMode ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "5ObBlW",
                                    defaultMessage: "Dark Mode"
                                }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "hVPucN",
                                    defaultMessage: "Light Mode"
                                })
                            }, "theme"),
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                leftSection: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faSignOut
                                }),
                                onClick: logoutUser,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "C81/uG",
                                    defaultMessage: "Logout"
                                })
                            }, "logout")
                        ]
                    }))
                ]
            })),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: adminChannelModalOpen,
                onClose: adminChannelModalHandlers.close,
                title: intl.formatMessage({
                    id: "194Y+K",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Manage Channel"
                        }
                    ]
                }),
                renderInput: function(inputProps) {
                    return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
                        placeholder: intl.formatMessage({
                            id: "hh0xW7",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Channel Name"
                                }
                            ]
                        })
                    }, inputProps));
                },
                description: intl.formatMessage({
                    id: "ZNueCe",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter the name of the channel you would like to manage."
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "0Azlrb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Manage"
                        }
                    ]
                }),
                onSubmit: handleAdminChannelChange
            })
        ]
    });
}
